/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import VueRouter from "vue-router";

import router from "./router/index";
import store from "./store/index";

import jQuery from "jquery";
window.$ = jQuery;

// Template libraries
require("../template/libraries/js/pace.min");
require("../template/libraries/js/template");

window.Vue = require("vue").default;

Vue.use(VueRouter);

import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import VueSweetalert2 from "vue-sweetalert2";
import draggable from "vuedraggable";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import FloatingVue from 'floating-vue'

import {
    ValidationProvider,
    ValidationObserver,
    extend,
    localize,
} from "vee-validate";
import es from "vee-validate/dist/locale/es.json";
import * as rules from "vee-validate/dist/rules";
import 'sweetalert2/dist/sweetalert2.min.css';

Object.keys(rules).forEach((rule) => {
    extend(rule, rules[rule]);
});

localize("es", es);

Vue.use(CKEditor);
Vue.use(VueSweetalert2);
Vue.use(FloatingVue)
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.config.devtools = true;
Vue.component("multiselect", Multiselect);
Vue.component("draggable", draggable);
Vue.component("date-picker", DatePicker);

import App from "./App.vue";
import Sidebar from "./layout/Sidebar.vue";

Vue.component(
    "template-uploader",
    require("./components/TemplateUploaderComponent.vue").default
);
Vue.component(
    "pdf-uploader",
    require("./components/PdfUploaderComponent.vue").default
);
// Vue.component(
//     "example-component",
//     require("./components/ExampleComponent.vue").default
// );
// Vue.component(
//     "contest-component",
//     require("./components/Contest/ContestComponent.vue").default
// );
Vue.component(
    "contest-list-component",
    require("./components/Contest/ContestListComponent.vue").default
);
Vue.component(
    "contest-view-component",
    require("./components/Contest/ContestViewComponent.vue").default
);
Vue.component(
    "contest-edit-component",
    require("./components/Contest/ContestEditComponent.vue").default
);
Vue.component(
    "contest-create-component",
    require("./components/Contest/ContestCreateComponent.vue").default
);
Vue.component(
    "contest-clone-component",
    require("./components/Contest/ContestCloneComponent.vue").default
);
Vue.component(
    "contest-form-basic-component",
    require("./components/Contest/ContestFormBasicComponent.vue").default
);
Vue.component(
    "contest-what-component",
    require("./components/Contest/ContestWhatComponent.vue").default
);
Vue.component(
    "contest-section-component",
    require("./components/Contest/ContestSectionComponent.vue").default
);
Vue.component(
    "contest-home-banner-component",
    require("./components/Contest/ContestHomeBannerComponent.vue").default
);
Vue.component(
    "contest-home-category-component",
    require("./components/Contest/ContestHomeCategoryComponent.vue").default
);
Vue.component(
    "contest-winner-component",
    require("./components/Contest/ContestWinnerComponent.vue").default
);
Vue.component(
    "contest-finalist-component",
    require("./components/Contest/ContestFinalistComponent.vue").default
);
Vue.component(
    "winner-banner-component",
    require("./components/Contest/ContestBannerWinnerComponent.vue").default
);
Vue.component(
    "contest-faq-component",
    require("./components/ContestFaq/ContestFaqComponent.vue").default
);
Vue.component(
    "contest-faq-list-component",
    require("./components/ContestFaq/ContestFaqListComponent.vue").default
);
Vue.component(
    "contest-faq-order-component",
    require("./components/ContestFaq/ContestFaqOrderComponent.vue").default
);
Vue.component(
    "contest-faq-section-component",
    require("./components/ContestFaq/ContestFaqSectionComponent.vue").default
);
Vue.component(
    "contest-faq-form-component",
    require("./components/ContestFaq/ContestFaqFormComponent.vue").default
);
Vue.component(
    "contest-adward-component",
    require("./components/ContestAdward/ContestAdwardComponent.vue").default
);
Vue.component(
    "contest-adward-form-component",
    require("./components/ContestAdward/ContestAdwardFormComponent.vue").default
);
Vue.component(
    "contest-adward-section-component",
    require("./components/ContestAdward/ContestAdwardSectionComponent.vue")
        .default
);
Vue.component(
    "contest-adward-list-component",
    require("./components/ContestAdward/ContestAdwardListComponent.vue").default
);
Vue.component(
    "contest-adward-order-component",
    require("./components/ContestAdward/ContestAdwardOrderComponent.vue")
        .default
);
Vue.component(
    "contest-criteria-component",
    require("./components/ContestCriteria/ContestCriteriaComponent.vue").default
);
Vue.component(
    "contest-criteria-form-component",
    require("./components/ContestCriteria/ContestCriteriaFormComponent.vue")
        .default
);
Vue.component(
    "contest-criteria-section-component",
    require("./components/ContestCriteria/ContestCriteriaSectionComponent.vue")
        .default
);
Vue.component(
    "contest-criteria-list-component",
    require("./components/ContestCriteria/ContestCriteriaListComponent.vue")
        .default
);
Vue.component(
    "contest-criteria-order-component",
    require("./components/ContestCriteria/ContestCriteriaOrderComponent.vue")
        .default
);
Vue.component(
    "contest-requirement-component",
    require("./components/ContestRequirement/ContestRequirementComponent.vue")
        .default
);
Vue.component(
    "contest-requirement-form-component",
    require("./components/ContestRequirement/ContestRequirementFormComponent.vue")
        .default
);
Vue.component(
    "contest-requirement-section-component",
    require("./components/ContestRequirement/ContestRequirementSectionComponent.vue")
        .default
);
Vue.component(
    "contest-requirement-list-component",
    require("./components/ContestRequirement/ContestRequirementListComponent.vue")
        .default
);
Vue.component(
    "contest-requirement-order-component",
    require("./components/ContestRequirement/ContestRequirementOrderComponent.vue")
        .default
);
Vue.component(
    "contest-category-component",
    require("./components/ContestCategory/ContestCategoryComponent.vue").default
);
Vue.component(
    "contest-category-form-component",
    require("./components/ContestCategory/ContestCategoryFormComponent.vue")
        .default
);
Vue.component(
    "contest-category-section-component",
    require("./components/ContestCategory/ContestCategorySectionComponent.vue")
        .default
);
Vue.component(
    "contest-category-list-component",
    require("./components/ContestCategory/ContestCategoryListComponent.vue")
        .default
);
Vue.component(
    "contest-activity-component",
    require("./components/ContestActivity/ContestActivityComponent.vue").default
);
Vue.component(
    "contest-activity-form-component",
    require("./components/ContestActivity/ContestActivityFormComponent.vue")
        .default
);
Vue.component(
    "contest-activity-section-component",
    require("./components/ContestActivity/ContestActivitySectionComponent.vue")
        .default
);
Vue.component(
    "contest-activity-list-component",
    require("./components/ContestActivity/ContestActivityListComponent.vue")
        .default
);
Vue.component(
    "contest-ally-component",
    require("./components/ContestAlly/ContestAllyComponent.vue").default
);
Vue.component(
    "contest-ally-form-component",
    require("./components/ContestAlly/ContestAllyFormComponent.vue").default
);
Vue.component(
    "contest-ally-section-component",
    require("./components/ContestAlly/ContestAllySectionComponent.vue").default
);
Vue.component(
    "contest-ally-list-component",
    require("./components/ContestAlly/ContestAllyListComponent.vue").default
);
Vue.component(
    "contest-ally-order-component",
    require("./components/ContestAlly/ContestAllyOrderComponent.vue").default
);
Vue.component(
    "contest-judge-component",
    require("./components/ContestJudge/ContestJudgeComponent.vue").default
);
Vue.component(
    "contest-judge-list-component",
    require("./components/ContestJudge/ContestJudgeListComponent.vue").default
);
Vue.component(
    "contest-judge-order-component",
    require("./components/ContestJudge/ContestJudgeOrderComponent.vue").default
);
Vue.component(
    "contest-judge-form-component",
    require("./components/ContestJudge/ContestJudgeFormComponent.vue").default
);
Vue.component(
    "contest-judge-section-component",
    require("./components/ContestJudge/ContestJudgeSectionComponent.vue")
        .default
);
// Vue.component(
//     "section-component",
//     require("./components/Section/SectionComponent.vue").default
// );
Vue.component(
    "section-banner-component",
    require("./components/Section/SectionBannerComponent.vue").default
);
Vue.component(
    "section-contest-current-component",
    require("./components/Section/SectionContestCurrentComponent.vue").default
);
Vue.component(
    "section-contest-previous-component",
    require("./components/Section/SectionContestPreviousComponent.vue").default
);
// Vue.component(
//     "novelty-component",
//     require("./components/Novelty/NoveltyComponent.vue").default
// );
Vue.component(
    "novelty-form-component",
    require("./components/Novelty/NoveltyFormComponent.vue").default
);
Vue.component(
    "novelty-section-component",
    require("./components/Novelty/NoveltySectionComponent.vue").default
);
Vue.component(
    "novelty-list-component",
    require("./components/Novelty/NoveltyListComponent.vue").default
);
Vue.component(
    "novelty-order-component",
    require("./components/Novelty/NoveltyOrderComponent.vue").default
);
// Vue.component(
//     "category-component",
//     require("./components/Category/CategoryComponent.vue").default
// );
Vue.component(
    "category-form-component",
    require("./components/Category/CategoryFormComponent.vue").default
);
Vue.component(
    "category-section-component",
    require("./components/Category/CategorySectionComponent.vue").default
);
Vue.component(
    "category-list-component",
    require("./components/Category/CategoryListComponent.vue").default
);
Vue.component(
    "category-order-component",
    require("./components/Category/CategoryOrderComponent.vue").default
);
// Vue.component(
//     "judge-component",
//     require("./components/Judge/JudgeComponent.vue").default
// );
Vue.component(
    "judge-form-component",
    require("./components/Judge/JudgeFormComponent.vue").default
);
Vue.component(
    "judge-list-component",
    require("./components/Judge/JudgeListComponent.vue").default
);
// Vue.component(
//     "term-component",
//     require("./components/Term/TermComponent.vue").default
// );
Vue.component(
    "term-form-component",
    require("./components/Term/TermFormComponent.vue").default
);
Vue.component(
    "term-section-component",
    require("./components/Term/TermSectionComponent.vue").default
);
Vue.component(
    "term-list-component",
    require("./components/Term/TermListComponent.vue").default
);
Vue.component(
    "term-order-component",
    require("./components/Term/TermOrderComponent.vue").default
);
// Vue.component(
//     "privacy-component",
//     require("./components/Privacy/PrivacyComponent.vue").default
// );
Vue.component(
    "privacy-form-component",
    require("./components/Privacy/PrivacyFormComponent.vue").default
);
Vue.component(
    "privacy-section-component",
    require("./components/Privacy/PrivacySectionComponent.vue").default
);
Vue.component(
    "privacy-list-component",
    require("./components/Privacy/PrivacyListComponent.vue").default
);
Vue.component(
    "privacy-order-component",
    require("./components/Privacy/PrivacyOrderComponent.vue").default
);
// Vue.component(
//     "doubt-component",
//     require("./components/Doubt/DoubtComponent.vue").default
// );
Vue.component(
    "doubt-form-component",
    require("./components/Doubt/DoubtFormComponent.vue").default
);
Vue.component(
    "doubt-list-component",
    require("./components/Doubt/DoubtListComponent.vue").default
);
Vue.component(
    "doubt-section-form-component",
    require("./components/Doubt/DoubtSectionFormComponent.vue").default
);
Vue.component(
    "doubt-section-success-component",
    require("./components/Doubt/DoubtSecctionSuccessComponent.vue").default
);
Vue.component(
    "seo-component",
    require("./components/SeoComponent.vue").default
);
Vue.component(
    "annual-sale-component",
    require("./components/AnnualSale/AnnualSaleComponent.vue").default
);
Vue.component(
    "annual-sale-form-component",
    require("./components/AnnualSale/AnnualSaleFormComponent.vue").default
);
Vue.component(
    "annual-sale-list-component",
    require("./components/AnnualSale/AnnualSaleListComponent.vue").default
);
Vue.component(
    "annual-sale-order-component",
    require("./components/AnnualSale/AnnualSaleOrderComponent.vue").default
);
Vue.component(
    "funding-source-component",
    require("./components/FundingSource/FundingSourceComponent.vue").default
);
Vue.component(
    "funding-source-form-component",
    require("./components/FundingSource/FundingSourceFormComponent.vue").default
);
Vue.component(
    "funding-source-list-component",
    require("./components/FundingSource/FundingSourceListComponent.vue").default
);
Vue.component(
    "funding-source-order-component",
    require("./components/FundingSource/FundingSourceOrderComponent.vue")
        .default
);
Vue.component(
    "education-level-component",
    require("./components/EducationLevel/EducationLevelComponent.vue").default
);
Vue.component(
    "education-level-form-component",
    require("./components/EducationLevel/EducationLevelFormComponent.vue")
        .default
);
Vue.component(
    "education-level-list-component",
    require("./components/EducationLevel/EducationLevelListComponent.vue")
        .default
);
Vue.component(
    "education-level-order-component",
    require("./components/EducationLevel/EducationLevelOrderComponent.vue")
        .default
);
Vue.component(
    "occupation-component",
    require("./components/Occupation/OccupationComponent.vue").default
);
Vue.component(
    "occupation-form-component",
    require("./components/Occupation/OccupationFormComponent.vue").default
);
Vue.component(
    "occupation-list-component",
    require("./components/Occupation/OccupationListComponent.vue").default
);
Vue.component(
    "occupation-order-component",
    require("./components/Occupation/OccupationOrderComponent.vue").default
);
Vue.component(
    "university-list-component",
    require("./components/University/UniversityListComponent.vue").default
);
Vue.component(
    "phase-component",
    require("./components/Phase/PhaseComponent.vue").default
);
Vue.component(
    "phase-form-component",
    require("./components/Phase/PhaseFormComponent.vue").default
);
Vue.component(
    "phase-list-component",
    require("./components/Phase/PhaseListComponent.vue").default
);
Vue.component(
    "phase-order-component",
    require("./components/Phase/PhaseOrderComponent.vue").default
);
Vue.component(
    "phase-list-component",
    require("./components/Phase/PhaseListComponent.vue").default
);
Vue.component(
    "project-Login-component",
    require("./components/Project/ProjectLogInComponent.vue").default
);
Vue.component(
    "project-information-project-component",
    require("./components/Project/ProjectInformationProjectComponent.vue")
        .default
);
Vue.component(
    "project-business-model-component",
    require("./components/Project/ProjectBusinessModelComponent.vue").default
);
Vue.component(
    "project-team-component",
    require("./components/Project/ProjectTeamComponent.vue").default
);
Vue.component(
    "project-summary-component",
    require("./components/Project/ProjectSummaryComponent.vue").default
);
Vue.component(
    "project-tips-video-component",
    require("./components/Project/ProjectTipsVideoComponent.vue").default
);
Vue.component(
    "project-tips-photo-component",
    require("./components/Project/ProjectTipsPhotoComponent.vue").default
);
Vue.component(
    "project-tips-example-component",
    require("./components/Project/ProjectTipsExampleComponent.vue").default
);
Vue.component(
    "project-successful-component",
    require("./components/Project/ProjectSuccessfulComponent.vue").default
);
Vue.component(
    "project-what-information-component",
    require("./components/Project/ProjectWhatInformationComponent.vue").default
);
Vue.component(
    "project-image-register-component",
    require("./components/Project/ProjectImageRegisterComponent.vue").default
);
Vue.component(
    "project-show-component",
    require("./components/Project/ProjectShowComponent.vue").default
);
Vue.component(
    "project-edit-component",
    require("./components/Project/ProjectEditComponent.vue").default
);
// Vue.component(
//     "project-component",
//     require("./components/Project/ProjectComponent.vue").default
// );
Vue.component(
    "project-inscription-component",
    require("./components/Project/ProjectInscriptionComponent.vue").default
);
Vue.component(
    "project-list-component",
    require("./components/Project/ProjectListComponent.vue").default
);
Vue.component(
    "project-finalist-component",
    require("./components/Project/ProjectFinalistComponent.vue").default
);
Vue.component(
    "project-section-component",
    require("./components/Project/ProjectSectionComponent.vue").default
);
Vue.component(
    "project-migration-module",
    require("./components/Project/MigrateProjectComponent.vue").default
);
Vue.component(
    "masive-email-module",
    require("./components/Project/MasiveEmailModule.vue").default
);
// Vue.component(
//     "habeas-data-component",
//     require("./components/HabeasData/HabeasDataComponent.vue").default
// );
Vue.component(
    "habeas-data-list-component",
    require("./components/HabeasData/HabeasDataListComponent.vue").default
);
Vue.component(
    "question-component",
    require("./components/ContestQuestion/QuestionComponent.vue").default
);
Vue.component(
    "question-form-component",
    require("./components/ContestQuestion/QuestionFormComponent.vue").default
);
Vue.component(
    "question-list-component",
    require("./components/ContestQuestion/QuestionListComponent.vue").default
);
Vue.component(
    "question-criteria-component",
    require("./components/ContestQuestionCriteria/QuestionCriteriaComponent.vue")
        .default
);
Vue.component(
    "question-criteria-form-component",
    require("./components/ContestQuestionCriteria/QuestionCriteriaFormComponent.vue")
        .default
);
Vue.component(
    "question-criteria-list-component",
    require("./components/ContestQuestionCriteria/QuestionCriteriaListComponent.vue")
        .default
);
Vue.component(
    "question-criteria-order-component",
    require("./components/ContestQuestionCriteria/QuestionCriteriaOrderComponent.vue")
        .default
);
// Vue.component(
//     "loguser-component",
//     require("./components/LogUser/LogUserListComponent.vue").default
// );
Vue.component(
    "config-question-component",
    require("./components/ContestConfigQuestion/ConfigQuestionComponent.vue")
        .default
);
Vue.component(
    "config-question-component-list",
    require("./components/ContestConfigQuestion/ConfigQuestionList.vue")
        .default
);
Vue.component(
    "config-question-component-edit",
    require("./components/ContestConfigQuestion/ConfigQuestionEdit.vue")
        .default
);
Vue.component(
    "config-question-component-order",
    require("./components/ContestConfigQuestion/ConfigQuestionOrder.vue")
        .default
);
// Vue.component(
//     "log-form-error-list-component",
//     require("./components/LogFormError/LogFormErrorListComponent.vue").default
// );
// Vue.component(
//     "user-component",
//     require("./components/User/UserComponent.vue").default
// );
Vue.component(
    "user-list-component",
    require("./components/User/UserListComponent.vue").default
);
Vue.component(
    "user-show-component",
    require("./components/User/UserShowComponent.vue").default
);
// Vue.component(
//     "checks-legals-component",
//     require("./components/ChecksLegals/ChecksLegalsComponent.vue").default
// );
Vue.component(
    "checks-legals-list-component",
    require("./components/ChecksLegals/ChecksLegalsListComponent.vue").default
);
// Vue.component(
//     "checks-authorized-component",
//     require("./components/ChecksAuthorized/ChecksAuthorizedComponent.vue")
//         .default
// );
Vue.component(
    "checks-authorized-list-component",
    require("./components/ChecksAuthorized/ChecksAuthorizedListComponent.vue")
        .default
);

// Sworn
Vue.component(
    "contest-sworn-component",
    require("./components/Contest/ContestSwornComponent.vue").default
);

Vue.component(
    "contest-sworn-resume-component",
    require("./components/Contest/ContestSwornResumeComponent.vue").default
);

Vue.component(
    "contest-sworn-list-component",
    require("./components/Contest/ContestSwornListComponent.vue").default
);

Vue.component(
    "contest-sworn-show-component",
    require("./components/Contest/ContestSwornShowComponent.vue").default
);

Vue.component(
    "contest-sworn-create-component",
    require("./components/Contest/ContestSwornCreateComponent.vue").default
);

Vue.component(
    "contest-sworn-edit-component",
    require("./components/Contest/ContestSwornEditComponent.vue").default
);

// Banner Prehome
Vue.component(
    "section-prehome-create-banner-component",
    require("./components/Section/SectionPrehomeCreateBannerComponent.vue").default
);

Vue.component(
    "section-prehome-edit-banner-component",
    require("./components/Section/SectionPrehomeEditBannerComponent.vue").default
);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app",
    components: { App, Sidebar },
    data: {
        menu: 0,
    },
    router,
    store,
});
